export interface City {
  id: CityId;
  title: string;
}

export enum CityId {
  Famagusta,
  Larnaca,
  Limassol,
  Nicosia,
  Paphos,
}
